var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.148V20.5h-6.05v-7.023H8.468V20.5H2.5V8.148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.119 10l10.5-9h0l10.5 9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalHome);
export default __webpack_public_path__ + "static/media/ModalHome.a52541d77b30850b94b1f2a8d7342184.svg";
export { ForwardRef as ReactComponent };